import React, { useMemo, useState } from "react";
import { BaseModal, IModalInstance, ModalHeader } from "@whatslly/ui-components/modals";
import { ModalButtons } from "@whatslly/ui-components/ModalButtons";
import styles from "./VerifyPhoneNumberCodeModal.module.scss";
import { TextInput } from "@whatslly/ui-components/v2/BaseElements/TextInput";
import { stripNumberStringToOnlyNumbers } from "@whatslly/commons/utils";
import { useTranslation } from "react-i18next";

export const VerifyPhoneNumberCodeModal: React.FC<IModalInstance<string> & { phone: string }> = ({ closeModal, phone }) => {
  const { t } = useTranslation();
  const [verifyCode, setVerifyCode] = useState<string | undefined>();

  const isValidInput = useMemo(() => {
    return (verifyCode ?? "").length === 6;
  }, [verifyCode]);

  return (
    <BaseModal
      header={<ModalHeader closeModal={() => closeModal()}>{t("whatsapp_business_api_settings_page.verifyModal.title")}</ModalHeader>}
      footer={
        <ModalButtons
          isSubmitDisabled={!isValidInput}
          testId="modal-buttons-submit-button"
          onCancel={() => closeModal()}
          onSubmit={() => closeModal(verifyCode)}
        />
      }
      closeOnClickOutside={false}
      closeOnEscape={false}
      closeModal={() => closeModal()}
      className={styles.modal}
    >
      <div data-testid="verify-phone-code-modal">
        <div className={styles.text}>{t("whatsapp_business_api_settings_page.verifyModal.text", { phone })}</div>
        <TextInput
          data-testid="verify-phone-code-input"
          containerClassName={styles.textInput}
          paddingInline={`none`}
          value={verifyCode}
          onChange={(event) => setVerifyCode(stripNumberStringToOnlyNumbers(event.target.value))}
        />
      </div>
    </BaseModal>
  );
};
